import { default as MuiBox, type BoxProps } from '@mui/material/Box'
import { default as MuiTypograpahy, type TypographyProps } from '@mui/material/Typography'

export * from '@mui/material/index'

export const Box = ({
  m,
  mt,
  mr,
  mb,
  ml,
  mx,
  my,
  p,
  pt,
  pr,
  pb,
  pl,
  px,
  py,
  width,
  height,
  minWidth,
  minHeight,
  maxWidth,
  maxHeight,
  display,
  flex,
  flexWrap,
  flexGrow,
  flexShrink,
  flexDirection,
  alignItems,
  justifyItems,
  alignContent,
  justifyContent,
  gap,
  color,
  textAlign,
  position,
  overflow,
  textOverflow,
  border,
  borderColor,
  borderRadius,
  borderBottom,
  bgcolor,
  gridArea,
  lineHeight,
  ...props
}: BoxProps['sx'] & BoxProps) => {
  return (
    <MuiBox
      sx={{
        m,
        mt,
        mr,
        mb,
        ml,
        mx,
        my,
        p,
        pt,
        pr,
        pb,
        pl,
        px,
        py,
        width,
        height,
        minWidth,
        minHeight,
        maxWidth,
        maxHeight,
        display,
        flex,
        flexWrap,
        flexGrow,
        flexShrink,
        flexDirection,
        alignItems,
        justifyItems,
        alignContent,
        justifyContent,
        gap,
        color,
        textAlign,
        position,
        overflow,
        textOverflow,
        border,
        borderColor,
        borderRadius,
        borderBottom,
        bgcolor,
        gridArea,
        lineHeight,
      }}
      {...props}
    />
  )
}

export const Typography = ({
  m,
  mt,
  mr,
  mb,
  ml,
  mx,
  my,
  p,
  pt,
  pr,
  pb,
  pl,
  px,
  py,
  display,
  flex,
  flexWrap,
  flexGrow,
  flexShrink,
  flexDirection,
  alignItems,
  justifyItems,
  alignContent,
  justifyContent,
  gap,
  color,
  textAlign,
  fontSize,
  fontWeight,
  fontStyle,
  lineHeight,
  letterSpacing,
  whiteSpace,
  width,
  ...props
}: TypographyProps['sx'] & TypographyProps) => {
  return (
    <MuiTypograpahy
      sx={{
        m,
        mt,
        mr,
        mb,
        ml,
        mx,
        my,
        p,
        pt,
        pr,
        pb,
        pl,
        px,
        py,
        display,
        flex,
        flexWrap,
        flexGrow,
        flexShrink,
        flexDirection,
        alignItems,
        justifyItems,
        alignContent,
        justifyContent,
        gap,
        color,
        textAlign,
        fontSize,
        fontWeight,
        fontStyle,
        lineHeight,
        letterSpacing,
        whiteSpace,
        width,
      }}
      {...props}
    />
  )
}
